import DefaultProduct from '../ProductModels/DefaultProduct'

export interface ProductPattern<T> {
  DefaultProduct: (product: DefaultProduct) => T
}

export interface ProductMatcher {
  match<T>(p: ProductPattern<T>): T
}

export abstract class Product implements ProductMatcher {
  abstract match<T>(p: ProductPattern<T>): T
}
